import { ArrowBack } from '@mui/icons-material';
import { Button, Container, Paper, Stack, Typography } from '@mui/material';
import { cloneDeep, get, set } from 'lodash';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import LoadingBackdrop from 'src/components/ui-component/loading/LoadingBackdrop';
import MUIAlert from 'src/components/ui-component/mui-alert/MUIAlert';
import { SendForgotPasswordMail } from 'src/lib/api/AuthUser';
import { ERROR_MESSAGE, FORM_FIELDS_TYPES, NOT_FOUND_ERROR_MESSAGE } from 'src/lib/constants/constant';
import { PAGES_URLS } from 'src/lib/constants/routes';
import { FormStrucItem } from 'src/lib/types/types';

const userNamePath = 'attributes.userName';
const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					path: userNamePath,
					type: FORM_FIELDS_TYPES.string,
					label: 'Benutzername',
				},
			],
		},
	];

	return struc;
};

function ForgotPassword() {
	const navigate = useNavigate();

	const [loading, setLoading] = useState(false);

	const [formValue, setFormValues] = useState({});
	const [formErrorMessage, setFormErrorMessage] = useState('');

	const [wsSuccess, setWsSuccess] = useState<boolean | null>(null);

	const handleChange = (path: string, value: any) => {
		console.log(' path ', path);
		console.log(' value ', value);
		let formValuesCopy = cloneDeep(formValue);
		set(formValuesCopy, path, value);
		setFormValues(formValuesCopy);
		setFormErrorMessage('');
	};

	const handleSubmit = async () => {
		console.log(' submit ', formValue);

		if (get(formValue, userNamePath, '').length <= 0) {
			setFormErrorMessage('Benutzername darf nicht leer sein.');
		} else {
			try {
				setLoading(true);
				const data = {
					username: get(formValue, userNamePath),
				};
				let res = await SendForgotPasswordMail(data);

				if (res) {
					setWsSuccess(true);
				}
			} catch (err: any) {
				let errorMsg = JSON.parse(get(err, 'message', ''));
				setFormErrorMessage(get(ERROR_MESSAGE, get(errorMsg, 'error.message', ''), NOT_FOUND_ERROR_MESSAGE));
				console.error('ERROR: sending passwort-reset link ', err);
			} finally {
				setLoading(false);
			}
		}
	};
	return (
		<Container>
			{loading && <LoadingBackdrop open={loading} />}
			{formErrorMessage ?
				<>
					<MUIAlert infoType={'error'} message={formErrorMessage} />
				</>
			:	null}

			{wsSuccess ?
				<>
					<MUIAlert
						infoType={'success'}
						title='E-Mail wurde verschickt'
						message={
							<>
								<Typography variant={'body2'}>
									Sie werden in Kürze eine E-Mail erhalten, mit der Sie Ihr Passwort zurücksetzen können. Sollte die E-Mail nicht ankommen,
									vergewissern Sie sich, dass Sie die E-Mail-Adresse verwenden, mit der Sie sich bei Antragssystem registriert haben, und
									diese richtig geschrieben haben.
								</Typography>
							</>
						}
					/>
				</>
			:	<>
					<Stack direction={'row'} justifyContent={'space-between'} sx={{ mt: '2rem' }}>
						<Typography variant='h3' component={'h1'}>
							{' '}
							Passwort vergessen
						</Typography>
						<Button variant={'outlined'} onClick={() => navigate(PAGES_URLS.Login)} startIcon={<ArrowBack />}>
							Zurück zur Login-Seite
						</Button>
					</Stack>

					<Paper sx={{ mt: '3rem', p: '2rem', backgroundColor: '#FFF' }}>
						<Typography>
							Geben Sie hier Ihre Benutzername ein. Sie werden in Kürze eine E-Mail erhalten, mit der Sie Ihr Passwort zurücksetzen können.
						</Typography>

						<CreateForm formStruc={formStruc()} formValues={formValue} updateFormValuesFunc={handleChange} />

						<Stack alignItems={'flex-end'}>
							<Button disabled={formErrorMessage.length > 0 ? true : false} onClick={handleSubmit} sx={{ mt: '2rem' }}>
								Abschicken
							</Button>
						</Stack>
					</Paper>
				</>
			}
		</Container>
	);
}

export default ForgotPassword;
